import React, { useState, useContext } from "react";
import styles from "./Modal.module.scss";
import { ThemeContext } from "../../../Context/ThemeContext";
import { isMobile } from "react-device-detect";
import { ReactComponent as Close } from "../../assets/round-close-24px.svg";
import FocusTrap from "focus-trap-react";

const Modal = ({
  children,
  isUserWayActive,
  title,
  close,
  finish,
  updateText,
  modalType,
  activeModal,
  setActiveModal,
}) => {
  const [isUpdateButtonHovered, setIsUpdateButtonHovered] = useState(false);
  const theme = useContext(ThemeContext);

  const updateButtonBottomMargin =
    (Array.isArray(theme?.hideClientElements) &&
    theme.hideClientElements.includes("hideFooter")
      ? -40
      : 0) +
    parseInt(
      getComputedStyle(document.documentElement).getPropertyValue(
        "--mlb-footer-offset"
      )
    );

  return (
    <FocusTrap
      active={modalType === activeModal}
      focusTrapOptions={{
        clickOutsideDeactivates: true,
      }}
    >
      <div className={styles["modal"]}>
        <div
          className={styles["content"]}
          role="dialog"
        >
          <div className={styles["header"]}>
            <div className={styles["title-container"]}>
              <div className={styles["title"]}>
                <span>{title}</span>
              </div>
            </div>
            <div className={styles["button-container"]}>
              <button
                type="button"
                className={styles["button"]}
                onClick={() => {
                  close();
                  setActiveModal(null);
                }}
              >
                <Close
                  className={styles["close"]}
                  alt="Close modal"
                />
              </button>
            </div>
          </div>
          <div className={styles["main"]}>
            <section>{children}</section>
          </div>
        </div>
        {updateText && (
          <div
            className={styles["footer"]}
            style={{
              marginBottom: updateButtonBottomMargin,
            }}
          >
            <div className={styles["confirm-button-container"]}>
              <button
                style={{
                  background: !isUpdateButtonHovered
                    ? theme.theme.primaryColour
                    : theme.theme.hoverColour,
                  maxWidth: isMobile && isUserWayActive ? "85%" : "100%",
                }}
                data-cy={"modalUpdateButton"}
                type="button"
                onMouseEnter={() => setIsUpdateButtonHovered(true)}
                onMouseLeave={() => setIsUpdateButtonHovered(false)}
                className={styles["confirm-button"]}
                onClick={finish}
              >
                <span className={styles["confirm-button-span"]}>
                  {updateText}
                </span>
              </button>
            </div>
          </div>
        )}
      </div>
    </FocusTrap>
  );
};

export default Modal;
